(function () {
    /* Molecules (ScienceIngredients) + Standards now render ABOVE the static
       evidence/sources layer so the organic-chemistry visuals land at the
       narrative climax instead of behind the citation wall. */
    function SoliaScienceMain() {
        return (React.createElement("div", null,
            React.createElement(ScienceHero, null),
            React.createElement(SciencePremise, null),
            React.createElement(ScienceIngredients, null),
            React.createElement(ScienceStandards, null)));
    }
    function SoliaScienceClose() {
        return (React.createElement("div", null,
            React.createElement(ScienceClose, { shopHref: "/pages/shop" })));
    }
    ReactDOM.createRoot(document.getElementById('solia-science-root')).render(React.createElement(SoliaScienceMain, null));
    ReactDOM.createRoot(document.getElementById('solia-science-root-close')).render(React.createElement(SoliaScienceClose, null));
})();
